<template>
  <div class="teams-page">
    <div v-if="!loading" class="teams-page__container">
      <!-- Page Header -->
      <header class="teams-page__header">
        <div class="header-info">
          <div class="header-info__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            <h1 class="header-info__title">Team Management</h1>
            <p class="header-info__subtitle">Manage roles and team members for your organization</p>
          </div>
        </div>
      </header>

      <!-- Stats Section -->
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-card__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43476 12.8512 1.80964 13.4763C1.18452 14.1014 0.833328 14.9493 0.833328 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.50001 9.16667C9.34096 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34096 2.5 7.50001 2.5C5.65906 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65906 9.16667 7.50001 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <p class="stat-card__label">Total Number of Roles</p>
          <p class="stat-card__value">{{ totalRoles }}</p>
        </div>

        <div class="stat-card">
          <div class="stat-card__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43476 12.8512 1.80964 13.4763C1.18452 14.1014 0.833328 14.9493 0.833328 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.50001 9.16667C9.34096 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34096 2.5 7.50001 2.5C5.65906 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65906 9.16667 7.50001 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.1667 17.5V15.8333C19.166 15.0948 18.9203 14.3773 18.4678 13.7936C18.0153 13.2099 17.3818 12.793 16.6667 12.6083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.3333 2.60834C14.0504 2.79192 14.6859 3.20892 15.1397 3.79359C15.5936 4.37827 15.84 5.09736 15.84 5.8375C15.84 6.57765 15.5936 7.29674 15.1397 7.88141C14.6859 8.46609 14.0504 8.88309 13.3333 9.06667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <p class="stat-card__label">Total Number of Team Members</p>
          <div v-if="visibleMembers.length !== 0" class="stat-card__avatars">
            <div
              v-for="(member, index) in visibleMembers"
              :key="member.id"
              class="stat-card__avatar"
              :style="{ marginLeft: index !== 0 ? '-10px' : '0' }"
            >
              {{ getInitials(member.fname, member.lname) }}
            </div>
            <div v-if="hiddenCount > 0" class="stat-card__avatar-count">
              +{{ hiddenCount }}
            </div>
          </div>
          <p v-else class="stat-card__value">0</p>
        </div>

        <DealRoomTeamInvite
          title="Invite Member"
          @member-added="fetchDashboardData"
          :disabled="!(canPerformAction('team:*') || canPerformAction('team:addMember'))"
        />
      </div>

      <!-- Main Content Card -->
      <div class="content-card">
        <TabsNav
          :tabs="tabs"
          :active-tab="activeTab"
          @tab-change="handleTabChange"
        >
          <template #action-button>
            <button
              v-if="activeTab === 'roles'"
              @click="navigateToCreateRole"
              class="btn-primary"
              :disabled="!(canPerformAction('team:*') || canPerformAction('team:addGroup'))"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 3.33337V12.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.33325 8H12.6666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Create Custom Role
            </button>
          </template>
        </TabsNav>

        <div class="content-card__body">
          <RolesTable
            v-if="activeTab === 'roles'"
            :roles="roles"
            :loading="tableLoading"
            @edit-role="handleEditRole"
            @delete-role="handleDeleteRole"
            :onAction="fetchDashboardData"
            :totalPages="totalPages"
            :currentPage="currentPage"
            @gotoPage="gotoPage"
            :isActionAllowed="canPerformAction('team:*') || canPerformAction('team:updateGroup')"
          />

          <div v-else-if="activeTab === 'members'">
            <MembersTable
              v-if="activeTab === 'members'"
              :members="members"
              :loading="tableLoading"
              @delete-member="handleDeleteMember"
              :isActionAllowed="canPerformAction('team:*') || canPerformAction('team:updateMember')"
            />
          </div>

          <div v-else-if="activeTab === 'activity'">
            <p>Activity</p>
          </div>

          <EmptyState v-if="shouldShowEmptyState">
            <template #message>
              <div class="empty-message">
                <div class="empty-message__icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <p v-if="activeTab === 'roles' && !roles.length" class="empty-message__text">
                  You currently do not have any roles defined
                </p>
                <p v-if="activeTab === 'members' && !members.length" class="empty-message__text">
                  You currently do not have any team members in your dealroom
                </p>
                <p v-if="activeTab === 'activity' && !activities.length" class="empty-message__text">
                  No activity has been recorded yet
                </p>
              </div>
            </template>
          </EmptyState>
        </div>
      </div>
    </div>

    <Loader v-if="loading" />
  </div>
</template>


<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useGetters, useActions } from "@/composables/useMapper";

import RolesTable from "@/components/teams/tables/RolesTable.vue";
import MembersTable from "@/components/teams/tables/MembersTable.vue";
import TabsNav from "@/components/teams/TabsNav.vue";
import EmptyState from "@/components/notification/EmptyState";
import DealRoomTeamInvite from "@/components/teams/DealRoomTeamInvite";
import { permissionsService } from "@/utils/permissionChecker.js"


const router = useRouter();
const store = useStore(); 

const { teamMembers, iamGroups } = useGetters('organisationModule', [
  'teamMembers',
  'iamGroups'
]);

const { 
  getIAMGroups, 
  getTeamMembers, 
  getTeamMember, 
  deleteRole,
  deleteMember 
} = useActions('organisationModule', [
  'getIAMGroups',
  'getTeamMembers',
  'getTeamMember',
  'deleteRole',
  'deleteMember'
]);

const { showToast } = useActions('', ['showToast']);

const loading = ref(false);
const tableLoading = ref(false);
const activities = ref([]);
const activeTab = ref("roles");
const visibleMembers = ref([]);
const hiddenCount = ref(0);

const roles = computed(() => iamGroups.value?.docs || []);
const totalRoles = computed(() => iamGroups.value?.totalDocs || 0);
const totalPages = computed(() => iamGroups.value?.totalPages || 0);
const currentPage = computed(() => iamGroups.value?.page || 0);
const members = computed(() => teamMembers.value || []);

// Checking permissions for user
const permissions = ref(null);

permissions.value = permissionsService.loadUserPermissions();

const canPerformAction = (action) => {
  return permissionsService.hasPermission(action);
};

const getInitials = (fname, lname) => {
  return `${fname?.charAt(0) ?? ""}${lname?.charAt(0) ?? ""}`.toUpperCase();
};

const tabs = [
  { id: "roles", label: "Roles" },
  { id: "members", label: "Members" },
  // { id: "activity", label: "Activity Log" },
];

const shouldShowEmptyState = computed(() => {
  if (activeTab.value === "roles")
    return !roles.value.length && !tableLoading.value;
  if (activeTab.value === "members")
    return !members.value.length && !tableLoading.value;
  if (activeTab.value === "activity")
    return !activities.value.length && !tableLoading.value;
  return false;
});

const fetchDashboardData = async () => {
  loading.value = true;
  try {
    await Promise.all([
      getIAMGroups(),
      getTeamMembers({ page: 1 }),
    ]);
    
    visibleMembers.value = members.value.length > 5
      ? members.value.slice(0, 5)
      : members.value;
    
    hiddenCount.value = members.value.length > 5
      ? Math.max(0, members.value.length - 5)
      : 0;

    fetchTeamMembersForRoles();
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};


const gotoPage = async (page) => {
  loading.value = true;
  try {
    await getTeamMembers({ page });
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};

const fetchRoles = async () => {
  tableLoading.value = true;
  try {
    await getIAMGroups();

    fetchTeamMembersForRoles();
  } catch (error) {
    console.log(error);
  } finally {
    tableLoading.value = false;
  }
};

const fetchTeamMembersForRoles = async () => {

  const localRoles = [...roles.value];
  
  for (const role of localRoles) {
    try {
      const response = await getTeamMember(role.id);
      role.teamMembers = response.data.data.docs || [];

    } catch (error) {
      console.log(`Failed to fetch team members for role ${role.id}:`, error);
      role.teamMembers = [];
    }
  }
  
  store.commit('organisationModule/SET_IAMGROUPS_WITH_MEMBERS', localRoles);
};

const fetchMembers = async () => {
  tableLoading.value = true;
  try {
    await getTeamMembers({ page: 1 });
  } catch (error) {
    console.log(error);
  } finally {
    tableLoading.value = false;
  }
};

const handleTabChange = (tabId) => {
  activeTab.value = tabId;

  if (tabId === "roles") {
    fetchRoles();
  } else if (tabId === "members") {
    fetchMembers();
  } else if (tabId === "activity") {
    // fetchActivityLog();
  }
};

const navigateToCreateRole = () => {
  router.push("/dashboard/teams/create-role");
};

const handleEditRole = (roleId) => {
  router.push(`/dashboard/teams/edit-role/${roleId}`);
};

const handleDeleteRole = async (roleId) => {

  try {
    const res = await deleteRole(roleId);

    if (res) {
      showToast({
        message: "Role successfully deleted",
        type: "success",
      });
    }

    fetchRoles();
  } catch (error) {
    console.log(error);
  }
};

const handleDeleteMember = async (memberId) => {

  try {
    const res = await deleteMember(memberId);

    if (res) {
      showToast({
        message: "Team member successfully deleted",
        type: "success",
      });
    }

    fetchMembers();
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  fetchDashboardData();
});

watch(
  () => router.currentRoute.value.query.tab,
  (newTabQuery) => {
    if (newTabQuery && tabs.some((tab) => tab.id === newTabQuery)) {
      activeTab.value = newTabQuery;
      handleTabChange(newTabQuery);
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.teams-page {
  width: 100%;
  padding-bottom: 40px;
  
  &__container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 16px;
    animation: fadeIn 0.3s ease-in-out;
  }
  
  &__header {
    margin-bottom: 24px;
  }
}

.header-info {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  
  &__icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    flex-shrink: 0;
  }
  
  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 4px 0;
  }
  
  &__subtitle {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 24px;
  
  &__icon {
    width: 40px;
    height: 40px;
    background: #EEF4FF;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    margin-bottom: 16px;
  }
  
  &__label {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0 0 8px 0;
  }
  
  &__value {
    font-family: 'DM Sans', sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #0F172A;
    margin: 0;
  }
  
  &__avatars {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  
  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #EEF4FF;
    border: 2px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #4D84FF;
  }
  
  &__avatar-count {
    margin-left: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
  }
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  overflow: hidden;
  
  &__body {
    padding: 24px;
  }
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: #4D84FF;
  border: none;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    background: #3B6FE8;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.empty-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  
  &__icon {
    width: 48px;
    height: 48px;
    background: #F1F5F9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748B;
    margin-bottom: 12px;
  }
  
  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>